import { useEffect, useState } from "react";
import axios from "axios";
import { AlertTriangle } from "lucide-react";
import { API } from "../lib/apiClient";

export function CustomerPortal({ token }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    (async () => {
      try { const r = await axios.get(`${API}/public/portal/${token}`); setData(r.data); }
      catch { setErr("Geçersiz veya süresi dolmuş portal linki."); }
    })();
  }, [token]);
  if (err) return <div className="loading-screen" data-testid="portal-error"><div className="loading-mark"><AlertTriangle size={32} color="#dc2626" /><h2 style={{ marginTop: 10 }}>Erişilemiyor</h2><p className="muted">{err}</p></div></div>;
  if (!data) return <div className="loading-screen" data-testid="portal-loading"><div className="loading-mark">Yükleniyor…</div></div>;
  const money0 = (v) => Number(v || 0).toLocaleString("tr-TR", { style: "currency", currency: "TRY", maximumFractionDigits: 0 });
  return (
    <div className="public-quote-page" data-testid="customer-portal-page" style={{ minHeight: "100vh", padding: 24, background: "linear-gradient(135deg,#eff6ff 0%,#f6f8fb 100%)" }}>
      <div className="panel" style={{ maxWidth: 760, margin: "0 auto", padding: 28 }}>
        <div style={{ marginBottom: 20 }}>
          <small className="muted">Müşteri Portalı</small>
          <h1 style={{ margin: "6px 0 2px", fontSize: 24 }}>{data.customer.name}</h1>
          <p className="muted small">Sigorta danışmanınız: {data.agent.name || "—"} · {data.customer.phone || ""}</p>
        </div>
        <div className="kpi-grid" style={{ marginBottom: 20 }}>
          <div className="panel" style={{ padding: 14 }}><small className="muted">Toplam Poliçe</small><strong style={{ display: "block", fontSize: 22, marginTop: 4 }}>{data.totals.policyCount}</strong></div>
          <div className="panel" style={{ padding: 14 }}><small className="muted">Toplam Prim</small><strong style={{ display: "block", fontSize: 22, marginTop: 4 }}>{money0(data.totals.totalPremium)}</strong></div>
          <div className="panel" style={{ padding: 14 }}><small className="muted">Yaklaşan Yenileme</small><strong style={{ display: "block", fontSize: 22, marginTop: 4 }}>{data.totals.upcomingCount}</strong></div>
        </div>
        {data.upcomingRenewals.length > 0 && (
          <section style={{ marginBottom: 22 }}>
            <h3 style={{ fontSize: 14, marginBottom: 10 }}>Yaklaşan Yenilemeler</h3>
            <div className="panel" style={{ padding: 0 }}>
              <table className="data-table" data-testid="portal-upcoming-table">
                <thead><tr><th>Poliçe</th><th>Branş</th><th>Plaka</th><th>Bitiş</th></tr></thead>
                <tbody>
                  {data.upcomingRenewals.map((p, i) => (
                    <tr key={i}><td>{p.policeNo || "—"}</td><td>{p.branch}</td><td>{p.plate || "—"}</td><td>{p.end}</td></tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
        )}
        <section>
          <h3 style={{ fontSize: 14, marginBottom: 10 }}>Tüm Poliçeleriniz</h3>
          <div className="panel" style={{ padding: 0 }}>
            <table className="data-table" data-testid="portal-all-policies-table">
              <thead><tr><th>Poliçe</th><th>Branş</th><th>Plaka</th><th>Şirket</th><th>Başlangıç</th><th>Bitiş</th><th>Prim</th></tr></thead>
              <tbody>
                {data.policies.map((p, i) => (
                  <tr key={i}>
                    <td><strong>{p.policeNo || "—"}</strong></td>
                    <td>{p.branch}</td>
                    <td>{p.plate || "—"}</td>
                    <td>{p.company || "—"}</td>
                    <td>{p.start}</td>
                    <td>{p.end}</td>
                    <td>{money0(p.premium)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {data.policies.length === 0 && <div className="muted small" style={{ padding: 16, textAlign: "center" }}>Henüz kayıt yok.</div>}
          </div>
        </section>
        <p className="muted small" style={{ textAlign: "center", marginTop: 24 }}>Veriler yalnızca sigortacınız tarafından güncellenir · {data.agent.email || ""}</p>
      </div>
    </div>
  );
}
